import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { StripeCardElementOptions } from "@stripe/stripe-js";
import axios from "axios"
import React, { useCallback, useState } from 'react'
import { useDispatch } from "react-redux";
import { hideAuthModals } from "../../../actions/ui";

import Button from '../../../components/Button';
import Text from "../../../components/Text";

const CARD_OPTIONS: StripeCardElementOptions = {
    iconStyle: "solid",
    style: {
        base: {
            // iconColor: "#c4f0ff",
            // color: "#fff",
            fontWeight: 500,
            fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
            fontSize: "16px",
            fontSmoothing: "antialiased",
            ":-webkit-autofill": { color: "#fce883" },
            "::placeholder": { color: "#522583" }
        },
        // invalid: {
        //     iconColor: "#ffc7ee",
        //     color: "#ffc7ee"
        // }
    }
}

export interface PaymentFormProps {
    clientSecret: string,
    done: Function
}


const PaymentForm: React.FC<PaymentFormProps> = ({ clientSecret, done }) => {
    const [success, setSuccess] = useState(false)
    const [message, setMessage] = useState("")
    const stripe = useStripe()
    const elements = useElements()
    const dispatch = useDispatch();

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault()
        try {

            if (stripe && elements && clientSecret && elements.getElement(CardElement)) {
                const cardElement = elements.getElement(CardElement);
                if (cardElement) {
                    const response = await stripe.confirmCardPayment(
                        clientSecret,
                        {
                            "payment_method": {
                                "card": cardElement,
                                "billing_details": {
                                    name: 'Jenny Rosen',
                                },
                            },
                        }
                    )
                    if (response.paymentIntent?.status == "succeeded") {
                        done()
                    }
                    else if (response.error?.message) {
                        setMessage(response.error?.message);
                    }

                }
            }
        } catch (error) {
            console.log(error)
        }

    }, [elements, clientSecret, dispatch]);
    // data?: ConfirmCardPaymentData,
    // options?: ConfirmCardPaymentOptions
    // const handleSubmit = async (e: Event) => {
    //     e.preventDefault()
    //     const {error, paymentMethod} = await stripe.createPaymentMethod({
    //         type: "card",
    //         card: elements.getElement(CardElement)
    //     })


    // if(!error) {
    //     try {
    //         const {id} = paymentMethod
    //         const response = await axios.post("http://localhost:4000/payment", {
    //             amount: 1000,
    //             id
    //         })

    //         if(response.data.success) {
    //             console.log("Successful payment")
    //             setSuccess(true)
    //         }

    //     } catch (error) {
    //         console.log("Error", error)
    //     }
    // } else {
    //     console.log(error.message)
    // }
    // }

    return (
        <>
            <span style={{ "color": "red" }}>
                {message}
            </span>
            {
                !success ?
                    <form onSubmit={handleSubmit}>
                        <fieldset className="FormGroup">
                            <div className="FormRow">
                                <CardElement options={CARD_OPTIONS} />
                            </div>
                        </fieldset>
                        <Button
                            type="submit"
                            block
                            className="mt-4"
                        >
                            <Text className="m-0" uppercase color="white">
                                Pay
                            </Text>
                        </Button>
                    </form>
                    :
                    <div>
                        <h2>You just bought a sweet spatula congrats this is the best decision of you're life</h2>
                    </div>
            }

        </>
    )
}
export default PaymentForm